// dependencies
import PropTypes from "prop-types";
import moment from "moment-timezone";
import React, { useState, useEffect } from "react";

const Timestamp = (props) => {
	const { timezone } = props;
	const [currentTime, setCurrentTime] = useState(new Date());

	useEffect(() => {
		const timer = setInterval(() => {
			setCurrentTime(new Date());
		}, 250);

		return () => {
			clearInterval(timer);
		};
	});

	return (
		<div>
			{moment(currentTime).tz(timezone).format("YYYY-MM-DD h:mm:ss a")} {timezone}
		</div>
	);
};

Timestamp.propTypes = {
	timezone: PropTypes.string,
};

Timestamp.defaultProps = {
	timezone: moment.tz.guess(),
};

export default Timestamp;
